module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-dynamic-form-item-container"
  }, [_c('div', {
    ref: "rtDynamicItem",
    staticClass: "rt-dynamic-form-item"
  }, [_c('div', {
    staticClass: "rt-dynamic-input-contain"
  }, _vm._l((_vm.valueArr), function(item, index) {
    return _c('div', {
      key: item._id,
      ref: item._id,
      refInFor: true,
      staticClass: "rt-dynamic-input-item",
      class: index === 0 ? '' : 'rt-dynamic_no_show_label'
    }, [_vm._t("default", function() {
      return [_c('rt-form-item', _vm._b({
        class: !index ? 'rt-form-item__empty-right' : '',
        attrs: {
          "label": !index ? _vm.label : '',
          "label-width": _vm.labelWidth
        },
        scopedSlots: _vm._u([{
          key: "labelOuterSide",
          fn: function() {
            return [(!!index) ? _c('rt-button', {
              attrs: {
                "icon-name": _vm.deleteBtnIcon,
                "icon-size": "24",
                "type": _vm.deleteBtnType,
                "text": ""
              },
              nativeOn: {
                "click": function($event) {
                  return _vm.removeItem(item._id)
                }
              }
            }) : _vm._e()]
          },
          proxy: true
        }], null, true)
      }, 'rt-form-item', _vm.$attrs, false), [_c('rt-input', {
        attrs: {
          "placeholder": _vm.$tx('请输入', 'xpc.form.pleaseEnter')
        },
        model: {
          value: (item.value),
          callback: function($$v) {
            _vm.$set(item, "value", $$v)
          },
          expression: "item.value"
        }
      })], 1)]
    }, {
      "row": item,
      "index": index,
      "removeMethed": _vm.removeItem
    })], 2)
  }), 0)]), _vm._v(" "), _c('rt-form-item', _vm._b({
    staticClass: "rt-dynamic-add-btn-contain",
    attrs: {
      "label-width": _vm.labelWidth
    }
  }, 'rt-form-item', _vm.$attrs, false), [_c('div', {
    staticClass: "input-add-btn",
    on: {
      "click": _vm.addItem
    }
  }, [(_vm.addBtnType === 'detail') ? _c('rt-detail-button', {
    attrs: {
      "type": _vm.addBtnType,
      "prefix-icon": _vm.addBtnIcon
    }
  }, [_vm._v("\n        " + _vm._s(_vm.addBtnText) + "\n      ")]) : _c('rt-button', {
    attrs: {
      "type": _vm.addBtnType,
      "icon-name": _vm.addBtnIcon
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$tx(_vm.addBtnText, 'xpc.form.addFormItem')) + "\n      ")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b552397"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/form/rtDynamicFormItem.vue
// module id = 2172
// module chunks = 137